// team/shared/components/TeamModal.js
import React from 'react';
import { Modal as MuiModal, Box, Backdrop } from '@mui/material';

const TeamModal = ({
    open,
    onClose,
    children,
    width = '55%',  // Default width that can be overridden
    maxWidth = 1000, // Default max-width that can be overridden
    height = '85%',  // Default height that can be overridden
    top = '5%',      // Default top position that can be overridden
    borderRadius = 8, // Default border radius matching CSV upload modal
    overflow = 'auto', // Default overflow, can be overridden to 'hidden' for flex layouts
    disableScrollLock = true,
    BackdropComponent = Backdrop,
    BackdropProps = {
        sx: {
            backdropFilter: 'blur(8px)',
            bgcolor: 'rgba(245, 245, 245, 0.7)',
        },
    },
    p = null,          // Custom padding
    sx = {},           // Additional styles for the inner Box
    'aria-labelledby': ariaLabelledBy,
    ...otherProps
}) => {
    return (
        <MuiModal
            open={open}
            onClose={onClose}
            disableScrollLock={disableScrollLock}
            BackdropComponent={BackdropComponent}
            BackdropProps={BackdropProps}
            aria-labelledby={ariaLabelledBy}
            {...otherProps}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: top === '5%' ? top : '50%',
                    left: '50%',
                    transform: top === '5%' ? 'translateX(-50%)' : 'translate(-50%, -50%)',
                    width: width,
                    maxWidth: maxWidth,
                    height: height,
                    bgcolor: 'background.paper',
                    borderRadius: borderRadius,
                    boxShadow: 24,
                    p: p !== null ? p : (top === '5%' ? 3 : 4), // Use custom p if provided, else default based on top
                    overflow: overflow,
                    outline: 'none',
                    ...sx, // Spread additional styles
                }}
            >
                {children}
            </Box>
        </MuiModal>
    );
};

export default TeamModal;




